import styled from 'styled-components';
// hooks
import useModal from 'hooks/common/useModal';
import useRedirectUrl from 'hooks/domain/review/useRedirectUrl';
// stylesd
import { palette } from 'cds/styles';

/**
 * 사이드 클래스 수강연장 / 강의이동
 * @param {object} props
 * @param {number} props.classId 클래스 ID
 * @param {number} props.remainCnt 남은 자리 개수
 * @param {boolean} props.isPayment 구매 여부
 * @param {boolean} props.isLogined 로그인 여부
 */
const Actions = ({ classId, remainCnt, isPayment, isLogined }) => {
  const { initModal } = useModal();
  const { setRedirectUrl } = useRedirectUrl();
  /**
   * 남은 자리 수
   * - DB단에서 최대: 30
   * - View단에서 최대: 19
   */
  const groupRemainCnt = remainCnt > 19 ? remainCnt - 11 : remainCnt;

  const onApply = () => {
    if (isLogined) {
      window.location.href = `${process.env.NEXT_PUBLIC_DEFAULT_HOST}/class/pay/payinfo/${classId}`;
    } else {
      setRedirectUrl({ type: 'payment' });
      initModal({ name: 'Login' });
    }
  };

  const onExtend = () => {
    window.location.href = `${process.env.NEXT_PUBLIC_DEFAULT_HOST}/class/pay/payinfo/${classId}`;
  };

  const onMove = () => {
    window.location.href = `${process.env.NEXT_PUBLIC_DEFAULT_HOST}/class/lecture/${classId}`;
  };

  return (
    <Layout className="noselect">
      {isPayment && (
        <>
          <Button isActive onClick={onExtend}>
            수강연장
          </Button>
          <Button onClick={onMove}>강의이동</Button>
        </>
      )}

      {!isPayment && (
        <Button isActive onClick={onApply}>
          수강신청
          <span>남은자리: {groupRemainCnt}</span>
        </Button>
      )}
    </Layout>
  );
};

const Layout = styled.div`
  margin-bottom: 12px;
`;

// TODO PHP와 임시적으로 색상 통일되어있음
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border-radius: 4px;
  background-color: ${({ isActive }) => (isActive ? '#ff0e15' : palette.grey060)};
  font-size: inherit;
  color: ${palette.white};
  transition: 0.1s ease;

  & > span {
    margin-left: 6px;
    font-size: 14px;
    line-height: 24px;
    color: #f7fe54;
  }

  & ~ & {
    margin-top: 12px;
  }
`;

export default Actions;
